import { Lightning } from '@lightningjs/sdk';
import { CONTENT_GAP } from './mosaicGrid.constant';
import { SELECTED_SIGNAL } from '../../../signals';
import { defaultContext, ITEMS_PER_ROW } from './mosaicGrid.style';

/**
 * The Mosaic TV is a container of channel, theme and setting entries
 *
 * @version 1.2.0
 * @see https://zeroheight.com/726d5c282/p/4401e0-mosaic-tv--v120/b/704312
 */
export default class MosaicGrid extends Lightning.Component {
  static _template() {
    return {
      Items: {},
      signals: {
        [SELECTED_SIGNAL]: true,
      },
    };
  }

  _init() {
    this._index = 0;
    this._items = [];
    this._itemsPerRow = 0;
    this._style = defaultContext;
    this._contentGap = CONTENT_GAP[this._style.screenSize];
  }

  set data(value) {
    const { items, itemType, itemSize } = value;

    this._items = items;
    this._itemsPerRow = ITEMS_PER_ROW[this._style.screenSize];
    const currentItemsCount = this.items.length;

    if (currentItemsCount === items.length) {
      return;
    }

    this.tag('Items').children = items.map((item, index) => ({
      item,
      type: itemType,
      w: itemSize.w,
      h: itemSize.h,
      ...this._calculateItemPosition(itemSize, index),
      passSignals: {
        [SELECTED_SIGNAL]: true,
      },
    }));

    this._refocus();
  }

  get items() {
    return this.tag('Items').children;
  }

  _calculateItemPosition(itemSize, index) {
    return {
      x: (itemSize.w + this._contentGap) * (index % this._itemsPerRow),
      y: (itemSize.h + this._contentGap) * Math.floor(index / this._itemsPerRow),
    };
  }

  _handleUp() {
    if (this._index >= this._itemsPerRow) {
      this._setIndex(this._index - this._itemsPerRow);

      return true;
    }

    return false;
  }

  _handleDown() {
    if (this._index + this._itemsPerRow <= this.items.length - 1) {
      this._setIndex(this._index + this._itemsPerRow);
    }

    return false;
  }

  _handleLeft() {
    if (this._index % this._itemsPerRow === 0) {
      return false;
    }
    if (this._index > 0) {
      this._setIndex(this._index - 1);

      return true;
    }

    return false;
  }

  _handleRight() {
    if (this._index < this.items.length - 1) {
      this._setIndex(this._index + 1);

      return true;
    }

    return false;
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._items[this._index]);

    return true;
  }

  _setIndex(index = this._index) {
    this._index = index;
  }

  _getFocused() {
    return this.items[this._index];
  }
}
